<template>
  <div class="search-engine-top">
    <div class="search-engine-top__block">
      <div class="search-engine-top__inner" style="transition: 3s linear width">
        <svg class="search-engine-top__icon" @click="handleOpen($event)">
          <use xlink:href="#svg-magnifying"></use>
        </svg>
      </div>
    </div>
    <Teleport to="body">
      <transition name="fade">
        <div v-if="isOpen" class="engine-top-modal" :style="styles">
          <div
            class="engine-top-container"
            :style="{
              'max-height':
                isResponseHasItemsToShow && response.url && screenWidth < 992
                  ? 'calc(100% - 99px)'
                  : '100%',
            }"
          >
            <div class="engine-top-header">
              <div class="engine-top-input">
                <input
                  ref="input"
                  type="text"
                  class="engine-top-input__input"
                  :placeholder="result.placeholder"
                  :value="value"
                  @input="handlerInput($event)"
                  @keyup.enter="goSearchCatalog"
                />
                <div class="engine-top-input__magnificence" @click="goSearchCatalog">
                  <svg class="engine-top-input__icon" @click="handleOpen($event)">
                    <use xlink:href="#svg-magnifying"></use>
                  </svg>
                </div>
              </div>

              <DefButtonCross @click="handlerClose()" />
            </div>
            <SearchTopResponse
              v-if="isResponseHasItemsToShow"
              :result="response"
              @selectSuggest="selectSuggest"
            />
            <div
              v-if="response && response.messages && !isResponseHasItemsToShow"
              class="search-engine-top__nothingFound"
            >
              {{ response.messages.nothingFound }}
              "<b class="search-engine-top__value">{{ value }}</b
              >"
            </div>
          </div>
          <div
            v-if="isResponseHasItemsToShow && response.url && screenWidth < 992"
            class="engine-top-footer"
          >
            <span v-if="response?.printQuantity" class="engine-top-footer__text">{{
              response?.printQuantity
            }}</span>
            <DefButtonPrimary :href="response.url">
              {{ response?.messages?.allResults }}
            </DefButtonPrimary>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useScreenWidth from '@use/useScreenWidth';
import Analytics from '@/utils/Analytics/Analytics';
import SearchTopResponse from '@components/Search/SearchEngineTop/SearchTopResponse.vue';
import DefButtonCross from '@components/Def/DefButtonCross/DefButtonCross.vue';
import { useResultsStore } from '@/storePinia/stores/results';

export default {
  name: 'SearchEngineTop',
  components: {
    DefButtonCross,
    SearchTopResponse,
    DefButtonPrimary,
  },
  data() {
    return {
      response: {},
      value: '',
      timeout: '',
      isOpen: false,
      inputAnimationStep: 0,
      headerHeight: 0,
      abortController: null,
      screenWidth: useScreenWidth(),

      styles: {},
      resultsStore: useResultsStore(),
    };
  },
  computed: {
    result() {
      return this.resultsStore.headSearch;
    },
    isResponseHasItemsToShow() {
      if (this.response?.products?.items?.length) {
        return true;
      }
      if (this.response?.sections?.slice(1)?.length) {
        return true;
      }
      if (this.response?.collections && Object.keys(this.response?.collections)?.length) {
        return true;
      }
      return false;
    },
  },
  watch: {
    screenWidth() {
      this.setHeaderHeight();
      this.isOpen = false;
    },
    isOpen(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.input) {
            this.$refs?.input?.focus();
          }
        });
      }
    },
  },
  mounted() {
    this.setHeaderHeight();
  },
  methods: {
    handlerInput(e) {
      this.value = e.target.value;

      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }

      this.getSearchElements();
    },
    async getSearchElements() {
      try {
        this.abortController = new AbortController();
        const { ajax } = this.result;

        if (ajax?.url && ajax?.searchName) {
          const response = await axios.get(ajax.url, {
            params: {
              action: ajax?.data?.action,
              [ajax.searchName]: this.value,
              ajax: 'y',
              ...this.resultsStore.getRequestLang,
            },
            signal: this.abortController.signal,
          });

          this.response = response.data || {};

          Analytics.search(response.data);

          this.handlerClickGtag();

          return response;
        }
        this.response = {};
      } catch (err) {
        console.error(err);
      }
    },
    handlerClickGtag() {
      try {
        const product = this.response?.gtag?.data;
        if (product) {
          gtag('event', 'add_to_cart', {
            send_to: 'AW-440849847',
            value: product.value,
            items: product.items,
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async handleOpen() {
      const header = this.$el.closest('.header, .product-menu, .catalog-fixed-controls');

      if (
        header.classList.contains('product-menu') ||
        header.classList.contains('catalog-fixed-controls')
      ) {
        this.styles.position = 'fixed';
      } else {
        this.styles.position = 'absolute';
      }

      if (header) {
        const clientRect = header.getBoundingClientRect();

        this.styles.top = `${clientRect.top + clientRect.height}px`;
        this.styles.height = `${window.innerHeight - (clientRect.top + clientRect.height)}px`;
      }

      if (this.value === '') {
        await this.getSearchElements();
      }
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        document.addEventListener('click', this.handlerAnotherClick, true);
      } else {
        document.removeEventListener('click', this.handlerAnotherClick, true);
        this.response = {};
      }
    },
    handlerAnotherClick({ target }) {
      const parent = target.closest('.engine-top-modal, .search-engine-top');

      if (!parent) {
        this.isOpen = false;
        document.removeEventListener('click', this.handlerAnotherClick);
      }
    },
    goSearchCatalog() {
      window.location.href = `${this.result.page.href}?q=${this.value}`;
    },
    setHeaderHeight() {
      const { height, y } = document.querySelector('.header')?.getBoundingClientRect();
      this.headerHeight = height + y;
    },
    selectSuggest(suggest) {
      this.value = suggest;
      this.getSearchElements();
    },
    handlerClose() {
      this.value = '';
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-engine-top {
  &__block {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 24px;
    height: 24px;
  }
  &__inner {
    display: flex;
    align-items: center;
    position: absolute;
    background-color: #fff;
    right: 0;
  }
  &__icon {
    width: 24px;
    height: 24px;
    transition: 0.2s linear fill, 0.2s linear transform;
    &:hover {
      cursor: pointer;
      fill: var(--color-link-hover-dark);
      transform: scale(1.1);
    }
  }
  &__response {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 4;
    background-color: #fff;
    color: var(--text-colour-primary);
    border: 1px solid #cacece;
  }
  &__elements {
    padding: 16px 16px 0;
    background: #f6f6f6;
    max-height: 388px;
    overflow-y: auto;
    @include point-md {
      padding: 24px 24px 0;
    }
    @include point-lg {
      padding: 24px 36px 0;
    }
  }

  &__bottom {
    display: flex;
    align-items: center;
    height: 76px;
    padding: 0 16px;
    background: #f6f6f6;
    @include point-md {
      padding: 0 36px;
    }
  }
  &__nothingFound {
    padding: 16px;
    line-height: 24px;
    @include point-md {
      padding: 24px;
    }
    @include point-lg {
      padding: 24px 36px;
    }
  }
  &__value {
    //background-color: var(--background-beige);
  }
  :deep(.def-button-primary) {
    padding: 0 18px;
    width: 100%;
    @include point-md {
      width: auto;
      padding: 0 48px;
    }
  }
  :deep(.search-engine-top-response-main) {
    @include point-md {
      display: grid;
      grid-template-columns: minmax(0, 0.6fr) minmax(0, 1fr);
      grid-column-gap: 16px;
    }
  }
}
.engine-top-modal {
  position: absolute;
  top: 200px;
  z-index: 1001;
  left: 0;
  right: 0;
  background-color: #fff;
  padding: 0 16px;
  border-top: 1px solid var(--border-grey);
  @include point-md {
    padding: 0 24px;
  }
  @include point-lg {
    border-top: 0;
  }
}
.engine-top-container {
  max-width: 984px;
  margin: 0 auto;
  overflow-y: auto;
  padding-right: 5px;
}
.engine-top-header {
  display: flex;
  align-items: center;
  margin: 16px 0;
  gap: 8px;
  @include point-md {
    margin: 24px 0;
  }
  :deep(.def-button-cross) {
    width: 44px;
    height: 44px;
  }
}
.engine-top-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--border-grey);
  &__text {
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    color: var(--color-dark-grey);
  }
  :deep(.def-button-primary) {
    display: flex;
    max-width: max-content;
    margin: 0 auto;
  }
}

.engine-top-input {
  display: flex;
  flex-grow: 1;
  &__input {
    flex-grow: 1;
    height: 42px;
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    border: 1px solid #c8c8c8;
    padding: 0 16px;
    border-radius: 0;
    &::placeholder {
      color: #5f5f67;
    }
  }
  &__magnificence {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    border-top: 1px solid #c8c8c8;
    border-right: 1px solid #c8c8c8;
    border-bottom: 1px solid #c8c8c8;
    cursor: pointer;
  }
  &__icon {
    width: 20px;
    height: 20px;
  }
}
</style>
